export default __webpack_public_path__ + "static/media/team-1.a477a0eb.png";